import { render, staticRenderFns } from "./CustomerRelatedLoansListItem.vue?vue&type=template&id=5c16acd6&scoped=true&lang=pug&"
import script from "./CustomerRelatedLoansListItem.vue?vue&type=script&lang=js&"
export * from "./CustomerRelatedLoansListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c16acd6",
  null
  
)

export default component.exports